"use strict";

var mssgCardWidget = function () {
  var mssgCardWidgetParams = {
    model: {
      selectedMssgAnswer: '',
      initialAnswer: '',
      serviceGrade: null
    },
    url: {},
    spasiboOffer: {},
    template: {}
  };

  function renderEvaluationGrade() {
    var $mssgGradeSection = $('.mssgs-grade-section');
    var gradeTemplate = "<div class=\"rating-wrap\">\n                <div class=\"rating-list\">\n                    <input id=\"serviceRating-5\"\n                           type=\"radio\"\n                           name=\"serviceRating\"\n                           disabled \n                           class=\"rating-item -small\">\n                    <label for=\"serviceRating-5\"></label>\n                    <input id=\"serviceRating-4\"\n                           type=\"radio\"\n                           name=\"serviceRating\"\n                           disabled \n                           class=\"rating-item -small\">\n                    <label for=\"serviceRating-4\"></label>\n                    <input id=\"serviceRating-3\"\n                            type=\"radio\"\n                            name=\"serviceRating\"\n                            disabled \n                            class=\"rating-item -small\">\n                    <label for=\"serviceRating-3\"></label>\n                    <input id=\"serviceRating-2\"\n                           type=\"radio\"\n                           name=\"serviceRating\"\n                           disabled \n                           class=\"rating-item -small\">\n                    <label for=\"serviceRating-2\"></label>\n                    <input id=\"serviceRating-1\"\n                           type=\"radio\"\n                           name=\"serviceRating\"\n                           disabled \n                           class=\"rating-item -small\">\n                    <label for=\"serviceRating-1\"></label>\n                </div>\n                <span class=\"rating-description\">\u0412\u0430\u0448\u0430 \u043E\u0446\u0435\u043D\u043A\u0430 \u0441\u0435\u0440\u0432\u0438\u0441\u0430</span>\n            </div>";
    $mssgGradeSection.append(gradeTemplate);
    $("#serviceRating-".concat(mssgCardWidgetParams.model.serviceGrade)).attr('checked', true);
  }

  function evaluateService(grade, comment, callback) {
    $.ajax({
      url: mssgCardWidgetParams.url.evaluateService,
      data: {
        siId: mssgCardWidgetParams.model.id,
        grade: grade,
        comment: comment
      },
      method: 'POST',
      success: function success(data) {
        callback(data);
      }
    });
  }

  function createAnswer(serviceID, callback) {
    $.ajax({
      url: "".concat(mssgCardWidgetParams.url.createAnswer).concat(serviceID, "/").concat(mssgCardWidgetParams.model.id),
      method: 'GET',
      success: function success(data) {
        callback(data);
      }
    });
  }

  function submitMssgAnswer(answerID, callback) {
    $.ajax({
      url: mssgCardWidgetParams.url.selectAnswer,
      data: {
        siId: mssgCardWidgetParams.model.id,
        acId: answerID
      },
      method: 'POST',
      success: function success(data) {
        callback(data);
      }
    });
  }

  function spasiboConfirmOffer() {
    $.ajax({
      url: mssgCardWidgetParams.url.confirmSpasiboOffer,
      data: {
        spasiboOfferId: mssgCardWidgetParams.spasiboOffer.id,
        serviceInstanseId: mssgCardWidgetParams.model.id
      },
      method: 'POST',
      success: function success(data) {
        if (data.Success) {
          modalDialog.busyIndicator(true);
          location.reload();
        } else modalDialog.showError(data.Result);
      }
    });
  }

  function unbindHandlers() {
    $(document).off('click', '#evaluateServiceBtn');
    $(document).off('change', '[name="newServiceRating"]');
    $(document).off('click', '.mssg-services-list .service-item');
    $(document).off('change', '.mssg-answer-options');
    $(document).off('click', '#submitMssgAnswerBtn');
    $(document).off('click', '#spasibo-offer');
    $(document).off('click', '#spasibo-redirect');
  }

  function bindHandlers() {
    $(document).on('click', '#evaluateServiceBtn', function () {
      $('[name="newServiceRating"]').attr('checked', false);
      $('#mssgEvaluationModal').showAsModal({
        title: 'Оценка качества сервиса',
        buttons: [{
          title: 'Отмена',
          big: true
        }, {
          title: 'Оценить',
          big: true,
          primary: true,
          onClick: function onClick() {
            var res = false;
            var grade = $('[name="newServiceRating"]:checked').val();
            var gradeVal = grade == undefined ? 0 : +grade;
            var comment = $('[name="GradeComment"]').val().trim();

            if (gradeVal === 0) {
              validation.setFieldInvalid($('[data-prop-name="ratingVal"]'), 'Пожалуйста, поставьте оценку');
            } else if (gradeVal <= 3 && !comment.length) {
              validation.setFieldInvalid($('[data-prop-name="ratingComment"]'), 'Пожалуйста, укажите комментарий к оценке');
            } else {
              evaluateService(gradeVal, comment, function (data) {
                if (data.Success) {
                  renderEvaluationGrade();
                  $('#evaluateServiceBtn').hide();
                  $('#mssgEvaluationModal').modalDlgClose();
                } else {
                  modalDialog.showBaseWnd({
                    title: 'Ошибка',
                    buttons: [{
                      title: 'Хорошо',
                      big: true,
                      primary: true
                    }],
                    onDrawContent: function onDrawContent() {
                      return data.Result;
                    }
                  });
                }
              });
            }

            return res;
          }
        }],
        onClose: function onClose() {
          $('[name="newServiceRating"]:checked').prop('checked', false);
          validation.setAllValid('#mssgEvaluationModal');
        }
      });
    });
    $(document).on('change', '[name="newServiceRating"]', function () {
      var $ratingField = $('[data-prop-name="ratingVal"]');
      var $commentField = $('[data-prop-name="ratingComment"]');
      mssgCardWidgetParams.model.serviceGrade = $(this).val();

      if (mssgCardWidgetParams.model.serviceGrade > 3) {
        validation.setFieldValid($commentField);
      }

      validation.setFieldValid($ratingField);
    });
    $(document).on('click', '.mssg-services-list .service-item', function () {
      var serviceID = $(this).attr('data-answer-service-id');
      modalDialog.busyIndicator(true);
      createAnswer(serviceID, function (template) {
        var $answerModal = $('#mssgAnswerModal').html(template);
        modalDialog.busyIndicator(false);
        $answerModal.showAsModal({
          isVertical: true,
          buttons: [{
            title: 'Отправить',
            big: true,
            primary: true,
            wide: true,
            onClick: function onClick() {
              var isValid = modalService.validateModalForm();

              if (isValid) {
                // improve submitRequest API
                modalService.submitRequest(function (res) {
                  modalDialog.showBaseWnd({
                    title: 'Запрос принят',
                    buttons: [{
                      title: 'Хорошо',
                      big: true,
                      primary: true
                    }],
                    onDrawContent: function onDrawContent() {
                      return res.Result;
                    }
                  });
                });
              }

              return isValid;
            }
          }],
          afterOpen: function afterOpen() {
            modalService.setTitle(); //LKCommon.initSelectric($('.ServiceInstanceCreateDialog .select'));
          }
        });
      });
    });
    $(document).on('change', '.mssg-answer-options', function () {
      var mssgAnswer = $(this).val();
      var $submitMssgAnswerBtn = $('#submitMssgAnswerBtn');
      var $valueArea = $('[data-prop-name="answer"]');

      if (mssgAnswer !== mssgCardWidgetParams.model.initialAnswer && mssgAnswer !== '') {
        $submitMssgAnswerBtn.attr('disabled', false);
      } else {
        $submitMssgAnswerBtn.attr('disabled', true);
      }

      mssgCardWidgetParams.model.selectedMssgAnswer = mssgAnswer;
      validation.setFieldValid($valueArea);
    });
    $(document).on('click', '#submitMssgAnswerBtn', function () {
      var answerID = mssgCardWidgetParams.model.selectedMssgAnswer;
      var $this = $(this);
      var $mssgAction = $('.mssg-answer-action');
      var $answerField = $mssgAction.closest('.field');
      var responseTxt = '(вы уже отвечали ранее)';
      var isValid = true;
      var dataSet = {
        answer: answerID
      };
      isValid = validation.validateRequiredValues(dataSet);

      if (isValid) {
        submitMssgAnswer(answerID, function () {
          $this.attr('disabled', true);
          $answerField.attr('data-label-desc', responseTxt);
          $answerField.find('.field-label-description').text(responseTxt);
          mssgCardWidgetParams.model.initialAnswer = answerID;
          modalDialog.showBaseWnd({
            title: 'Ответ учтен',
            buttons: [{
              title: 'Хорошо',
              big: true,
              primary: true
            }],
            onDrawContent: function onDrawContent() {
              return 'Спасибо за Ваш ответ';
            }
          });
        });
      }
    });
    $(document).on('focus', '#GradeComment', function () {
      var $commentField = $('[data-prop-name="ratingComment"]');
      validation.setFieldValid($commentField);
    });
    $(document).on('click', '#spasibo-offer', function () {
      var hasConfirmedOffer = false;
      modalDialog.showBaseWnd({
        title: mssgCardWidgetParams.spasiboOffer.title,
        size: 'large',
        inputs: [{
          id: 'offerConfirm',
          title: 'Я согласен с офертой',
          type: 'checkbox'
        }],
        buttons: [{
          title: 'Хорошо',
          big: true,
          primary: true,
          disabled: true,
          onClick: function onClick() {
            if ($('#offerConfirm').is(':checked')) {
              hasConfirmedOffer = true;
            }
          }
        }],
        footer: {
          classNames: '-accented'
        },
        onDrawContent: function onDrawContent() {
          return mssgCardWidgetParams.spasiboOffer.text;
        },
        onClose: function onClose() {
          if (hasConfirmedOffer) {
            spasiboConfirmOffer();
          }
        }
      });
    });
    $(document).on('click', '#spasibo-redirect', function () {
      modalDialog.busyIndicator(true);
      location.href = mssgCardWidgetParams.url.spasiboRedirect;
    });
  }

  function setParams(mssgParams) {
    mssgCardWidgetParams = $.extend({}, mssgCardWidgetParams, mssgParams);
  }

  function cacheNodes() {}

  function init(mssgParams) {
    unbindHandlers();
    LKCommon.initSelectric($('.mssg-answer-options'));
    setParams(mssgParams);
    cacheNodes();
    bindHandlers();
  }

  return {
    init: init
  };
}();